import React, { useState } from 'react';
import ListItem from "@mui/material/List";
import { NavLink, Link } from "react-router-dom";
import Logo1 from '../../images/logo-1.png';
import './style.css';

const menus = [
    {
        id: 1,
        title: 'Accueil',
        link: '/home',
    },
    {
        id: 88,
        title: 'À propos',
        link: '/about',
    },
    {
        id: 3,
        title: 'Services',
        link: '/service',
    },
    {
        id: 4,
        title: 'Projets',
        link: '/project',
    },
    // {
    //     id: 40,
    //     title: 'Actualités',
    //     link: '/blog',
    // },
 
    {
        id: 6,
        title: 'Contact',
        link: '/contact',
    }
]


const MobileMenu = () => {

    const [menuActive, setMenuState] = useState(false);

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    const closeMenu = () => {
        setMenuState(false);
    }

    return (
        <div>
            <div className={`mobileMenu ${menuActive ? "show" : ""}`}>
                <div className="menu-close">
                    <div className="clox" onClick={() => setMenuState(!menuActive)}><i className="ti-close"></i></div>
                </div>

                <div className="mobileMenu-logo">
                    <Link
                        to="/home"
                        onClick={() => {
                            closeMenu();
                            ClickHandler();
                        }}
                    >
                        <img src={Logo1} alt="Diamond Alu" />
                    </Link>
                </div>

                <ul className="responsivemenu">
                    {menus.map((item, mn) => {
                        return (
                            <ListItem key={mn}>
                                <NavLink className="active"
                                    onClick={() => {
                                        ClickHandler();
                                        closeMenu();
                                    }}
                                    to={item.link}>{item.title}</NavLink>
                            </ListItem>
                        )
                    })}
                </ul>

            </div>

            <div className="showmenu mobail-menu" onClick={() => setMenuState(!menuActive)}>
                <button type="button" className="navbar-toggler open-btn">
                    <span className="icon-bar first-angle"></span>
                    <span className="icon-bar middle-angle"></span>
                    <span className="icon-bar last-angle"></span>
                </button>
            </div>
        </div>
    )
}

export default MobileMenu;